import { Label } from './common/label'
import { useForm } from './form'

export const FormSimpleText = ({ name, label, required, hidden, readonly, placeholder, defaultValue, autoFocus, autoComplete }) => {
  const { register } = useForm(name, { required, defaultValue, shouldDirty: true })

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <input
        className={`form-control ${readonly && 'bg-secondary-subtle'}`}
        {...register()}
        readOnly={readonly}
        autoComplete={autoComplete}
        placeholder={placeholder || label || name}
        autoFocus={autoFocus}
      />
    </Label>
  )
}
